package com.elan.edubridge.ui.shell

/**
 * `/qr?a=&s=&n=` — 앱 미설치 대응 착지 화면(가이드 §3.5.4, 계획 §3.6).
 *
 * 🔴 보안: **nonce(`n` 쿼리 파라미터)는 절대 읽지 않는다.** 웹에서 출결 처리를 허용하면
 * 계획 §3.4의 1회성 QR nonce 재사용 방어가 무의미해지기 때문이다.
 *
 * [render]는 매개변수를 아예 받지 않는다 — 라우트 등록(Main.kt)도 `RouteContext`(쿼리 포함)를
 * 이 함수에 넘기지 않으므로, `a`(academyId)·`s`(sessionId)·`n`(nonce) 중 어느 것도 변수에
 * 담기거나, 로그로 나가거나, 네트워크 호출에 실리지 않는다 — 코드에 애초에 읽는 지점이 없다.
 * 안내 문구는 전부 정적 텍스트다.
 *
 * QR 을 스캔하는 쪽은 학생이므로 배지는 학생·보호자 앱만 보여 준다(관리자 앱은 QR 을 띄우는 쪽이다).
 */
object QrLandingPage {
    fun render() {
        renderPage("eb-qr-landing", html())
    }

    private fun html(): String = """
        ${icon("icon-bridge-logo", "xl")}
        <h1>EduBridge 앱에서 출결을 처리할 수 있어요</h1>
        <p class="eb-meta">이 QR은 앱 전용이에요. 아래에서 학생·보호자용 EduBridge 앱을 내려받거나, 선생님께 수동 출결을 요청하세요.</p>
        ${studentAppBadges()}
        <a class="eb-button eb-button--ghost" href="/login">웹으로 로그인</a>
    """.trimIndent()
}
